<!-- NEW FILE -->
<div class="drawer">
	<div class="drawer-title">
		Staff breakdown <span class="muted" *ngIf="hotelName">• {{ hotelName }}</span>
	</div>

	<div *ngIf="(rows?.length ?? 0) > 0; else empty">
		<table class="drawer-table">
			<thead>
			<tr>
				<th>Name</th>
				<th class="drawer-amount">Claimed</th>
				<th class="drawer-amount">Completed</th>
				<th class="drawer-amount">Completion</th>
				<th class="drawer-amount">Av. Days</th>
			</tr>
			</thead>

			<tbody>
			<tr *ngFor="let s of rows" [class.is-zero]="(s.completed ?? 0) === 0">
				<td class="report-name" [title]="s.email">
					{{ s.fullName }}
				</td>

				<td class="drawer-amount">{{ s.claimed }}</td>
				<td class="drawer-amount">{{ s.completed }}</td>
				<td class="drawer-amount">{{ completionRateText(s) }}</td>
				<td class="drawer-amount">{{ avgDaysText(s.avgDaysToComplete) }}</td>
			</tr>
			</tbody>
		</table>
	</div>

	<ng-template #empty>
		<div class="drawer-empty">No staff activity found for this hotel in the selected range.</div>
	</ng-template>
</div>
